export default __webpack_public_path__ + "static/media/join-bottom.008f0e13.svg";